import React, { Fragment, FunctionComponent, PropsWithChildren } from "react";

export type TabProps = PropsWithChildren<{
  /** název záložky */
  // eslint-disable-next-line react-redux/no-unused-prop-types
  tabName: string;
}>;

export const Tab: FunctionComponent<TabProps> = ({ children }) => <Fragment>{children}</Fragment>;
